import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LogOut, X } from 'lucide-react';

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const LogoutModal: React.FC<LogoutModalProps> = ({ isOpen, onClose, onConfirm }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm"
            onClick={onClose}
          />
          <div className="fixed inset-0 z-[101] flex items-start justify-center pt-[15vh] pointer-events-none">
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: -20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: -20 }}
              className="bg-card w-full max-w-md mx-4 rounded-2xl shadow-2xl border pointer-events-auto overflow-hidden"
            >
              <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center text-destructive">
                    <LogOut className="w-6 h-6" />
                  </div>
                  <button
                    onClick={onClose}
                    className="p-2 rounded-lg hover:bg-accent transition-colors"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
                
                <h3 className="text-xl font-bold mb-2">Conferma Uscita</h3>
                <p className="text-muted-foreground mb-8">
                  Sei sicuro di voler uscire? Dovrai reinserire le tue credenziali al prossimo accesso per sicurezza.
                </p>
                
                <div className="flex space-x-3">
                  <button
                    onClick={onClose}
                    className="flex-1 px-4 py-2 rounded-xl border font-medium hover:bg-accent transition-colors"
                  >
                    Annulla
                  </button>
                  <button
                    onClick={onConfirm}
                    className="flex-1 px-4 py-2 rounded-xl bg-destructive text-destructive-foreground font-medium hover:opacity-90 transition-opacity"
                  >
                    Esci
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
};
